export enum MeasureType {
  outerLength = 'outerLength',
  innerLength = 'innerLength',
  width = 'width',
  height = 'height',
}
